import type { ThreeElements } from '@react-three/fiber';
import Smoke from './smoke';
import Flame from './flame';
import { StaticCollider } from 'bvhecctrl';
import { CookingMesh } from './cooking-mesh';

export const Campfire = (props: ThreeElements['group']) => {
  return (
    <group {...props}>
      <Flame />
      <Smoke position={[0, 0.39, 0]} />
      <StaticCollider>
        <CookingMesh />
      </StaticCollider>
    </group>
  );
};
